import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { NO_TEAMS_TOKEN } from '../interceptors/teams.interceptor';
import { NO_ERROR_TOKEN } from '../interceptors/error.interceptor';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { IClubPermission } from '../interfaces/club-permission.interface';


/**
 * Check could club download the videos or add them to playlist
 */
@Injectable({
  providedIn: 'root'
})
export class ClubPermissionService {
  private allowedVideoDownload = false;
  private allowedAddToPlaylist = false;

  constructor(private http: HttpClient) {
  }

  public checkPermission(): Observable<IClubPermission> {
    return this.http.get<IClubPermission>(environment.apiUrl + '/Clubs/Settings', {context: this.getContext()})
      .pipe(
        catchError(() => of({
          allowedVideoDownload: false,
          allowedAddToPlaylist: false
        })),
        tap(response => {
          this.allowedVideoDownload = response?.allowedVideoDownload ?? false;
          this.allowedAddToPlaylist = response?.allowedAddToPlaylist ?? false;
        })
      );
  }

  private getContext(): HttpContext {
    const context = new HttpContext();
    context.set(NO_TEAMS_TOKEN, true);
    context.set(NO_ERROR_TOKEN, true);

    return context;
  }

  get download(): boolean {
    return this.allowedVideoDownload;
  }

  get addToPlaylist(): boolean {
    return this.allowedAddToPlaylist;
  }
}
